export default __webpack_public_path__ + "static/media/my-avatar.9c9fcf2a.svg";